import { render } from "./MessageList.vue?vue&type=template&id=068b3b48&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"

import "./MessageList.vue?vue&type=style&index=0&id=068b3b48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068b3b48"]])

export default __exports__